module.exports = __webpack_public_path__ + "static/bg09-e771d25f6525e419d0c3699055e361b0.webp";